import { ofType, StateObservable } from 'redux-observable';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, concatMap, map, switchMap } from 'rxjs/operators';

import { Dependencies } from '../../../store';
import { PayloadAction } from '../../../store.model';
import { ActionType } from '../focus-selector.action';
import { InitEpicChainGroup } from '../model/focus-selector-init-epic-chain-group.model';

import {
    FocusSelectorInit,
    FocusSelectorInitResult,
    focusSelectorInitResultMain,
} from './init.action';
import {
    retrieveFocusesForPerformer,
    retrieveGoalThresholds,
} from './init.epic.function';

export const initEpic = (
    action: Observable<PayloadAction<ActionType, FocusSelectorInit>>,
    state: StateObservable<any>,
    deps: Dependencies,
): Observable<PayloadAction<ActionType, FocusSelectorInitResult>> =>
    action.pipe(
        ofType(ActionType.COACHING_FOCUS_SELECTOR__INIT),
        switchMap((act: PayloadAction<ActionType, FocusSelectorInit>) => {
            const grp: InitEpicChainGroup = {
                root: act.payload,
            };

            return of(null).pipe(
                concatMap(() => {
                    return forkJoin([
                        of(null).pipe(retrieveFocusesForPerformer(deps, grp)),
                        of(null).pipe(retrieveGoalThresholds(deps, grp)),
                    ]);
                }),
                map(() => {
                    return focusSelectorInitResultMain(
                        {
                            coachId: act.payload.coachId,
                            performerId: act.payload.performerId,
                            commitmentId: act.payload.commitmentId,
                            initSelectedFocus: act.payload.selectedFocus,
                            active: grp.active,
                            closed: grp.closed,
                            teamActive: grp.teamActive,
                            teamClosed: grp.teamClosed,
                            coachableMetrics: grp.coachableMetrics,
                            userBehaviours: grp.populationFocuses,
                            goalThresholds: grp.goalThresholds,
                            other: grp.other,
                        },
                        act.storePath,
                    );
                }),
                catchError((err) => {
                    console.log(err);
                    return of(
                        focusSelectorInitResultMain(
                            {
                                coachId: act.payload.coachId,
                                performerId: act.payload.performerId,
                                commitmentId: act.payload.commitmentId,
                                initSelectedFocus: act.payload.selectedFocus,
                                active: [],
                                closed: [],
                                teamActive: [],
                                teamClosed: [],
                                coachableMetrics: [],
                                userBehaviours: [],
                                goalThresholds: [],
                                other: [],
                            },
                            act.storePath,
                        ),
                    );
                }),
            );
        }),
    );
